import * as React from "react";
import type { SVGProps } from "react";
const SvgChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={16}
    fill="none"
    {...props}
  >
    <g fill="#050033" fillOpacity={0.2} clipPath="url(#chat_svg__a)">
      <path d="M7.568 11.096V7.673a2.88 2.88 0 0 1 2.877-2.875h5.832v-.71A3.15 3.15 0 0 0 13.133.941H3.588A3.15 3.15 0 0 0 .441 4.088v4.444a3.15 3.15 0 0 0 3.147 3.15h1.728l-.421 2.292a.173.173 0 0 0 .276.169l2.6-1.989a2.9 2.9 0 0 1-.203-1.058" />
      <path d="M17.795 5.284h-7.35a2.393 2.393 0 0 0-2.391 2.389v3.423a2.393 2.393 0 0 0 2.39 2.39h3.605l2.527 1.93a.13.13 0 0 0 .152.01.13.13 0 0 0 .06-.14l-.336-1.8h1.337a2.39 2.39 0 0 0 2.39-2.39V7.673a2.39 2.39 0 0 0-2.384-2.39" />
    </g>
    <defs>
      <clipPath id="chat_svg__a">
        <path fill="#fff" d="M0 .5h20.625v15H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChat;
